// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-content[data-v-9d86a98e]{margin-bottom:26px;font-size:14px;color:#333;line-height:22px}", ""]);
// Exports
module.exports = exports;
